const Wakelock = function(global) {
    const log = global.log.getLogger("f_mtac.application.wakelock");
    const supported_wake_lock = ("wakeLock" in navigator) ? true : false;

    var state = null;

    this.enable = async () => {
        if (!supported_wake_lock) {
            return;
        }
        try {
            state = await navigator.wakeLock.request("screen");
            state.addEventListener("release", () => {
                log.warn("screen lock disabled");
                state = null;
            });
            log.warn("screen lock is active");
        } catch (err) {
            log.error(`${err.name}, ${err.message}`);
        }
        const on_visibility_change = async () => {
            if (document.visibilityState !== "visible") {
                return;
            }
            try {
                if (state !== null) {
                    state.release();
                }
            } catch (err) {
                log.error(`${err.name}, ${err.message}`);
            }
            try {
                state = await navigator.wakeLock.request("screen");
                state.addEventListener("release", () => {
                    log.warn("screen lock disabled");
                });
            } catch (err) {
                log.error(`${err.name}, ${err.message}`);
            }
        };
        document.addEventListener("visibilitychange", on_visibility_change);
        document.addEventListener("fullscreenchange", on_visibility_change);
    };

    this.disable = () => {
        if (!supported_wake_lock) {
            return;
        }
        if (state === null) {
            return;
        }
        document.removeEventListener("visibilitychange");
        document.removeEventListener("fullscreenchange");
        state.release();
        state = null;
    };
};

export default Wakelock;
